const about = state => state;
const brokerageInfo = state => state.brokerageInfo;
export default {
    about,
    brokerageInfo
};
